import React, { Suspense } from 'react';
import { ThemeProvider } from '@metaicg/sensei-ui';
import { GlobalStyles } from '@/shared/styles/styles';
import routes from '@/routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { NotificationContainer } from '@/shared/utils/notifier';
import { sentryUseRoutes } from '@/shared/services/sentry';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const router = sentryUseRoutes(routes);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider enableTypography>
        <GlobalStyles />
        <Suspense fallback={null}>{router}</Suspense>
        <NotificationContainer />
      </ThemeProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen />}
    </QueryClientProvider>
  );
}

export default App;
